// src/config.js
// const API_BASE_URL = 'http://localhost:8080/api';
const API_BASE_URL = 'https://api.signblast.com.au/api';
// not in use const API_BASE_URL = 'http://new-ims-dev-vm.australiaeast.cloudapp.azure.com:8080/api';

export default API_BASE_URL;